<script setup lang="ts">
  import { IconRadio } from '@/shared/ui';

  defineProps<{
    modelValue: string;
    label: string;
    action: string;
  }>();

  defineEmits<{
    (e: 'update:modelValue', value: string): void;
  }>();
</script>

<template>
  <IconRadio
    id="approve"
    :model-value="modelValue"
    :value="action"
    :label="label"
    name="approval"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
